function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M16.993 15.953h-5.695c-.555 0-1.007.46-1.007 1.024 0 .565.452 1.023 1.007 1.023h5.695c.555 0 1.007-.458 1.007-1.023s-.452-1.024-1.007-1.024z",
  fill: "#1163F0"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.31 3.904l5.395 4.36a.31.31 0 01.05.429L6.36 17.028a2.1 2.1 0 01-1.63.817l-3.492.043a.398.398 0 01-.391-.312l-.794-3.45c-.138-.634 0-1.29.402-1.795l6.429-8.376a.3.3 0 01.426-.051z",
  fill: "#1163F0"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M15.12 5.665l-1.04 1.299a.298.298 0 01-.423.048c-1.264-1.023-4.503-3.65-5.4-4.377a.308.308 0 01-.044-.432L9.216.957c.91-1.172 2.497-1.28 3.778-.258l1.47 1.172c.604.473 1.006 1.096 1.143 1.752.16.721-.01 1.43-.486 2.042z",
  fill: "#1163F0"
});
function SvgEditRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgEditRequest;